import { Injectable, signal } from '@angular/core';





@Injectable({ providedIn: 'root' })
export class LoadingStateService {
  private readonly _loading = signal<boolean>(false);
  public readonly loading = this._loading.asReadonly();

  public stopLoading(): void {
    this._loading.set(false);
  }

  public startLoading(): void {
    this._loading.set(true);
  }
}
